import { Pipe, PipeTransform } from '@angular/core';

import { parseDDMMYYYToDate } from '../utils/date.utils';
import { sortArray } from '../utils/utility-functions.utils';
import { SortByTypeEnum } from './../enums/sort-by.enum';

@Pipe({
    name: 'sortByDate',
})
export class SortByDate implements PipeTransform {
    public transform(array: any[], key?: string, direction: 'asc' | 'desc' = 'desc'): any[] {
        if (array && array.length >= 1 && key) {
            return sortArray(array, key, direction, SortByTypeEnum.DATE);
        }
        return array;
    }
}

@Pipe({
    name: 'sortByDateString',
})
export class SortByDateString implements PipeTransform {
    public transform(array: any[], key?: string, direction: 'asc' | 'desc' = 'desc'): any[] {
        if (array && array.length >= 1 && key) {
            return direction === 'asc'
                ? array.sort((a: any, b: any) => parseDDMMYYYToDate(a[key]).getTime() - parseDDMMYYYToDate(b[key]).getTime())
                : array.sort((a: any, b: any) => parseDDMMYYYToDate(b[key]).getTime() - parseDDMMYYYToDate(a[key]).getTime());
        } else if (array && array.length >= 1 && (!key || key === '')) {
            return direction === 'asc'
                ? array.sort((a: any, b: any) => parseDDMMYYYToDate(a).getTime() - parseDDMMYYYToDate(b).getTime())
                : array.sort((a: any, b: any) => parseDDMMYYYToDate(b).getTime() - parseDDMMYYYToDate(a).getTime());
        }
        return array;
    }
}
